import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'
import { MedicalNotesFormattedFetchParams, MedicalNotesResult } from '~/interfaces/llm'
import { message } from '~/services'
import { fetchMedicalNotesFormattedForLLM } from '~/services/llm'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'medicalNotesFormattedForLLM'

export const useFetchMedicalNotesFormattedForLLM = (
  params: MedicalNotesFormattedFetchParams,
  config?: UseQueryOptions<MedicalNotesResult, Error, MedicalNotesResult>
): UseQueryResult<MedicalNotesResult, Error> => {
  const fetcher = async (): Promise<MedicalNotesResult> => {
    try {
      return await fetchMedicalNotesFormattedForLLM(params)
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  const hasParams = (): boolean => hasObjectValue({ params })

  return useQuery<MedicalNotesResult, Error>([UNIQUE_KEY, params], async () => await fetcher(), {
    enabled: hasParams(),
    cacheTime: Infinity,
    staleTime: Infinity,
    ...config
  })
}
